export default __webpack_public_path__ + "static/media/diyg_default_img_01.5a6ad0d3.png";